export default __webpack_public_path__ + "static/media/img-video-sign-up-merchants.51e212d9.jpg";